__turbopack_context__.v({
  "active": "ChatModule-module__HajQhG__active",
  "appWindow": "ChatModule-module__HajQhG__appWindow",
  "audioMsg": "ChatModule-module__HajQhG__audioMsg",
  "avatar": "ChatModule-module__HajQhG__avatar",
  "avatarWrapper": "ChatModule-module__HajQhG__avatarWrapper",
  "badge": "ChatModule-module__HajQhG__badge",
  "blink": "ChatModule-module__HajQhG__blink",
  "bounceDot": "ChatModule-module__HajQhG__bounceDot",
  "channelBadge": "ChatModule-module__HajQhG__channelBadge",
  "chatBody": "ChatModule-module__HajQhG__chatBody",
  "chatFooter": "ChatModule-module__HajQhG__chatFooter",
  "chatHeader": "ChatModule-module__HajQhG__chatHeader",
  "chatHeaderLeft": "ChatModule-module__HajQhG__chatHeaderLeft",
  "chatHeaderName": "ChatModule-module__HajQhG__chatHeaderName",
  "chatHeaderVia": "ChatModule-module__HajQhG__chatHeaderVia",
  "chatRow": "ChatModule-module__HajQhG__chatRow",
  "clicked": "ChatModule-module__HajQhG__clicked",
  "crmBox": "ChatModule-module__HajQhG__crmBox",
  "crmBoxDesc": "ChatModule-module__HajQhG__crmBoxDesc",
  "crmBoxHeader": "ChatModule-module__HajQhG__crmBoxHeader",
  "crmBtn": "ChatModule-module__HajQhG__crmBtn",
  "crmSectionTitle": "ChatModule-module__HajQhG__crmSectionTitle",
  "crmTag": "ChatModule-module__HajQhG__crmTag",
  "crmTags": "ChatModule-module__HajQhG__crmTags",
  "cursor": "ChatModule-module__HajQhG__cursor",
  "description": "ChatModule-module__HajQhG__description",
  "dot": "ChatModule-module__HajQhG__dot",
  "emptyTag": "ChatModule-module__HajQhG__emptyTag",
  "fadeIn": "ChatModule-module__HajQhG__fadeIn",
  "featureIcon": "ChatModule-module__HajQhG__featureIcon",
  "featureItem": "ChatModule-module__HajQhG__featureItem",
  "featureList": "ChatModule-module__HajQhG__featureList",
  "filterTab": "ChatModule-module__HajQhG__filterTab",
  "filterTabs": "ChatModule-module__HajQhG__filterTabs",
  "inputFake": "ChatModule-module__HajQhG__inputFake",
  "mockupContainer": "ChatModule-module__HajQhG__mockupContainer",
  "moduleWrapper": "ChatModule-module__HajQhG__moduleWrapper",
  "msgBot": "ChatModule-module__HajQhG__msgBot",
  "msgBubble": "ChatModule-module__HajQhG__msgBubble",
  "msgIn": "ChatModule-module__HajQhG__msgIn",
  "msgNote": "ChatModule-module__HajQhG__msgNote",
  "msgOut": "ChatModule-module__HajQhG__msgOut",
  "msgTime": "ChatModule-module__HajQhG__msgTime",
  "popBubble": "ChatModule-module__HajQhG__popBubble",
  "profileAvatar": "ChatModule-module__HajQhG__profileAvatar",
  "profileName": "ChatModule-module__HajQhG__profileName",
  "resolveBtn": "ChatModule-module__HajQhG__resolveBtn",
  "rowMsg": "ChatModule-module__HajQhG__rowMsg",
  "rowName": "ChatModule-module__HajQhG__rowName",
  "rowText": "ChatModule-module__HajQhG__rowText",
  "searchBar": "ChatModule-module__HajQhG__searchBar",
  "sendCircle": "ChatModule-module__HajQhG__sendCircle",
  "slaBadge": "ChatModule-module__HajQhG__slaBadge",
  "systemAlert": "ChatModule-module__HajQhG__systemAlert",
  "textContent": "ChatModule-module__HajQhG__textContent",
  "title": "ChatModule-module__HajQhG__title",
  "typingIndicator": "ChatModule-module__HajQhG__typingIndicator",
  "unreadCount": "ChatModule-module__HajQhG__unreadCount",
  "wmChatList": "ChatModule-module__HajQhG__wmChatList",
  "wmDetails": "ChatModule-module__HajQhG__wmDetails",
  "wmMain": "ChatModule-module__HajQhG__wmMain",
  "wmSidebar": "ChatModule-module__HajQhG__wmSidebar",
  "wmSidebarHeader": "ChatModule-module__HajQhG__wmSidebarHeader",
});
